import AddButton from 'components/buttons/AddButton'
import DoctorListAction from 'components/data-table/data-table-action/admin-action/DoctorListAction';
import DataTable from 'components/data-table/DataTable'
import Loader from 'components/loader/Loader'
import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { Col, Container, Row } from 'reactstrap'
import { DoctorListRes, DoctorListTodo } from 'redux/slice/admin/doctor/DoctorList'

class DoctorList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            bool: false
        };
    }

    componentDidMount() {
        const { dispatch } = this.props;
        this.setState({ loading: true });
        dispatch(DoctorListTodo()).then(() => this.List_res());
    }

    componentDidUpdate(prevProps, prevState) {
        const { dispatch } = this.props;
        if (prevState.bool !== this.state.bool) {
            dispatch(DoctorListTodo()).then(() => this.List_res());
        }
    }

    setBool = () => {
        this.setState(prevState => ({ bool: !prevState.bool }));
    }


    List_res = () => {
        if (DoctorListRes?.success) {
            this.setState({ loading: false });
        } else if (DoctorListRes?.error?.status == 401) {
            localStorage.clear()
            this.props.history.push('/admin/login');
        } else {
            this.setState({ loading: false });
        }
    }
    render() {

        const { loading, bool } = this.state;
        const { DoctorList } = this.props;
        const columnDefs = [
            {
                headerName: 'S.NO',
                valueGetter: 'node.rowIndex + 1',
                filter: 'false',
                suppressMenu: true,
                sortable: true,
                floatingFilter: false,
                maxWidth: 90
            },
            {
                headerName: 'NAME',
                field: 'name',
                filter: 'agTextColumnFilter',
                suppressMenu: true,
                filter: true,
                sortable: true,
                floatingFilter: false,
            },
            {
                headerName: 'IMAGE',
                field: 'doctorImage',
                cellRenderer: params => <div className='table_img_sec'>
                    <img className=" img-fluid table_data_img" src={process.env.REACT_APP_IMAGE_URL + params?.data?.doctorImage} alt="image" />
                </div>,
                filter: 'agTextColumnFilter',
                suppressMenu: true,
                autoHeight: true,
                filter: true,
                sortable: true,
                floatingFilter: false,
                maxWidth: 120,
                // wrapText: true,
                // autoHeight: true,
            },
            {
                headerName: 'CONTACT',
                field: 'mobile',
                filter: 'agTextColumnFilter',
                suppressMenu: true,
                filter: true,
                sortable: true,
                floatingFilter: false,
            },
            {
                headerName: 'QUALIFICATION',
                field: 'qualification',
                filter: 'agTextColumnFilter',
                suppressMenu: true,
                filter: true,
                sortable: true,
                floatingFilter: false,
            },
            {
                headerName: 'SPECILIZATION',
                field: 'specilization',
                filter: 'agTextColumnFilter',
                suppressMenu: true,
                filter: true,
                sortable: true,
                floatingFilter: false,
            },
            // {
            //     headerName: 'FEES',
            //     field: 'price',
            //     filter: 'agTextColumnFilter',
            //     suppressMenu: true,
            //     filter: true,
            //     sortable: true,
            //     floatingFilter: false,
            // },
            {
                headerName: 'STATUS',
                field: 'status',
                filter: 'agTextColumnFilter',
                // cellRenderer: params => (
                //     <span className={params.value === 'Active' ? 'badge bg-success' : 'badge bg-danger'}>
                //         {params.value}
                //     </span>
                // ),
                cellRenderer: params => params.value === 'Active' ? <span className='active-status'>Active</span> : <span className='inactive-status'>Inactive</span>,
                suppressMenu: true,
                filter: true,
                sortable: true,
                floatingFilter: false,
                maxWidth: 120
            },
            {
                field: 'ACTIONS',
                cellRenderer: DoctorListAction,
                cellRendererParams: {
                    bool: bool,
                    setBool: this.setBool,
                },
                autoHeight: true,
                pinned: 'right',
                maxWidth: 120,
            }
        ];
        return (
            <>
                <div className="page-content">
                    <Container fluid>
                        <div className='d-flex justify-content-between align-items-center'>
                            <h4 className="mb-0 font-size-18">Doctor List</h4>
                            <Link to='/admin/add-doctor'> <AddButton name={"ADD DOCTOR"} /></Link>
                        </div>
                        <Row>
                            <Col xl='12' className='mt-2'>
                                {loading ?
                                    <div className='dd-flex justify-content-center p-5'>
                                        <Loader />
                                    </div> :
                                    <DataTable
                                        rowData={DoctorList}
                                        columnDefs={columnDefs}
                                        height={'70vh'}
                                    />}
                            </Col>
                        </Row>
                    </Container>
                </div>
            </>
        )
    }
}
const mapStateToProps = state => ({
    DoctorList: state?.DoctorList?.data?.data,
    // departmentListRes: state.DepartmentListRes // Adjust based on where `departmentListRes` is stored
});
export default connect(mapStateToProps)(DoctorList)
